import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BrandsListComponent } from './pages/brands-list/brands-list.component'
import { CategoriesListComponent } from './pages/categories-list/categories-list.component'
import { OrderListComponent } from './pages/order-list/order-list.component'
import { OrderDetailsComponent } from './pages/order-details/order-details.component'

const routes: Routes = [
	{
		path: 'brands',
		component: BrandsListComponent,
	},
	{
		path: 'categories',
		component: CategoriesListComponent,
	},

	{
		path: 'orders',
		component: OrderListComponent,
	},
	{
		path: 'orders/order-details/:id',
		component: OrderDetailsComponent,
	},
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class StoreRoutingModule {}
